import React, { Fragment, useContext, useState } from "react";
import AuthContext from "../../services/firebase/auth-context/provider";
import FirebaseHandler from "../../services/firebase";
import styles from "./login.module.css";
import LoadingSpinner from "../common/loading-spinner";
import { createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import MakroAlert, { MakroAlertType } from "../common/alert";
const InputField = _ref => {
    let { label, type, name, value, onChange, required = false } = _ref;
    const { 0: isFocused, 1: setIsFocused } = useState(false);
    const { 0: isPassVisible, 1: setIsPassVisible } = useState(false);
    const getType = () => type === "password" ? isPassVisible ? "text" : "password" : type;
    return /*#__PURE__*/ React.createElement("div", {
        className: "inline-block relative max-w-full w-full py-5"
    }, /*#__PURE__*/ React.createElement("label", {
        className: `${styles.emailLabel}
      ${!isFocused && !value ? styles.largeLabel : styles.smallLabel}`,
        htmlFor: name
    }, label), /*#__PURE__*/ React.createElement("input", {
        type: getType(),
        name: name,
        required: required,
        className: styles.emailInput,
        value: value,
        onFocus: () => setIsFocused(true),
        onBlur: () => setIsFocused(false),
        onChange: onChange
    }), type === "password" && /*#__PURE__*/ React.createElement("span", {
        className: `${styles.showPassIcon} ${isPassVisible ? styles.activeIcon : ""}`,
        onClick: () => setIsPassVisible(!isPassVisible)
    }));
};
const TermsAndConditions = () => /*#__PURE__*/ React.createElement("div", {
    className: "px-6"
}, /*#__PURE__*/ React.createElement("p", {
    className: styles.termsAndConditions
}, "Indem Sie fortfahren, stimmen Sie", /*#__PURE__*/ React.createElement("a", {
    href: "/agb/",
    className: styles.link,
    target: "_blank"
}, " unseren Nutzungsbedingungen"), " und ", /*#__PURE__*/ React.createElement("a", {
    href: "/datenschutz/",
    className: styles.link,
    target: "_blank"
}, "unserer Datenschutzerkl\xE4rung"), " zu."));
const CustomLoadingSpinner = () => /*#__PURE__*/ React.createElement("div", {
    className: "flex items-center justify-center absolute h-8 w-20"
}, /*#__PURE__*/ React.createElement(LoadingSpinner, {
    color: "makroOrangeLight"
}));
const Login = _ref2 => {
    let { initialMode = LoginMode.LOGIN } = _ref2;
    const { authenticated, user } = useContext(AuthContext)[0];
    const { 0: state, 1: setState } = useState("NONE");
    const { 0: mode, 1: setMode } = useState(evaluateLoginModeSettings(initialMode));
    const { 0: credentials, 1: setCredentials } = useState({
        email: "",
        pass: ""
    });
    const { 0: dedicatedErrorMessage, 1: setDedicatedErrorMessage } = useState(undefined);
    const onSubmit = async (e) => {
        e.preventDefault();
        const { email, pass } = credentials;
        try {
            setState("LOADING");
            if (mode.mode === LoginMode.LOGIN) {
                await signInWithEmailAndPassword(FirebaseHandler.auth, email, pass);
            }
            else if (mode.mode === LoginMode.REGISTER) {
                await createUserWithEmailAndPassword(FirebaseHandler.auth, email, pass);
            }
            else if (mode.mode === LoginMode.FORGOT_PASSWORD) {
                await sendPasswordResetEmail(FirebaseHandler.auth, email);
            }
            setState("SUCCESS");
        }
        catch (err) {
            setState("ERROR");
            setDedicatedErrorMessage(determineDedicatedErrorMessage(err));
        }
    };
    const changeMode = mode => {
        setState("NONE");
        setMode(evaluateLoginModeSettings(mode));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "makroLogin"
    }, !authenticated ? /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: `${styles.mainContainer} ${styles.shadow}`
    }, /*#__PURE__*/ React.createElement("form", {
        className: styles.form,
        onSubmit: onSubmit
    }, /*#__PURE__*/ React.createElement("div", {
        className: "pt-6 px-6"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: styles.title
    }, mode.title)), state == "ERROR" && /*#__PURE__*/ React.createElement("div", {
        className: "pt-4 px-6"
    }, /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.DANGER,
        title: "Fehler",
        text: dedicatedErrorMessage ? dedicatedErrorMessage : mode.error
    })), state == "SUCCESS" && mode.success && /*#__PURE__*/ React.createElement("div", {
        className: "pt-4 px-6"
    }, /*#__PURE__*/ React.createElement(MakroAlert, {
        type: MakroAlertType.SUCCESS,
        text: mode.success
    })), /*#__PURE__*/ React.createElement("div", {
        className: "pt-4 px-6"
    }, /*#__PURE__*/ React.createElement(InputField, {
        label: "E-Mail Adresse",
        type: "email",
        name: "email",
        required: true,
        value: credentials.email,
        onChange: e => setCredentials({
            ...credentials,
            email: e.target.value
        })
    }), mode.mode !== LoginMode.FORGOT_PASSWORD && /*#__PURE__*/ React.createElement(InputField, {
        label: "Passwort",
        type: "password",
        name: "newPassword",
        required: true,
        value: credentials.pass,
        onChange: e => setCredentials({
            ...credentials,
            pass: e.target.value
        })
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.buttonContainer
    }, mode.mode !== LoginMode.LOGIN && /*#__PURE__*/ React.createElement("span", {
        className: styles.link,
        onClick: () => changeMode(LoginMode.LOGIN)
    }, "Anmelden"), mode.mode !== LoginMode.REGISTER && /*#__PURE__*/ React.createElement("span", {
        className: styles.link,
        onClick: () => changeMode(LoginMode.REGISTER)
    }, "Registrieren"), mode.mode !== LoginMode.FORGOT_PASSWORD && /*#__PURE__*/ React.createElement("span", {
        className: styles.link,
        onClick: () => changeMode(LoginMode.FORGOT_PASSWORD)
    }, "Passwort vergessen?"), /*#__PURE__*/ React.createElement("button", {
        disabled: state == "LOADING",
        type: "submit",
        className: `${styles.button} ${styles.shadow}`
    }, state == "LOADING" ? /*#__PURE__*/ React.createElement(CustomLoadingSpinner, null) : mode.submitButtonText))), /*#__PURE__*/ React.createElement(TermsAndConditions, null))) : /*#__PURE__*/ React.createElement(Fragment, null, "Angemeldet als ", /*#__PURE__*/ React.createElement("strong", null, user.email), "."));
};
export default Login;
export let LoginMode = /*#__PURE__*/ function (LoginMode) {
    LoginMode[LoginMode["LOGIN"] = 0] = "LOGIN";
    LoginMode[LoginMode["REGISTER"] = 1] = "REGISTER";
    LoginMode[LoginMode["FORGOT_PASSWORD"] = 2] = "FORGOT_PASSWORD";
    return LoginMode;
}({});
const evaluateLoginModeSettings = mode => {
    switch (mode) {
        case LoginMode.REGISTER:
            return {
                mode: LoginMode.REGISTER,
                title: "Erstellen Sie einen Account",
                submitButtonText: "Registrieren",
                success: "Registrierung erfolgreich",
                error: "Bitte versuchen Sie es erneut."
            };
        case LoginMode.FORGOT_PASSWORD:
            return {
                mode: LoginMode.FORGOT_PASSWORD,
                title: "Fordern Sie einen Link zum Zurücksetzen Ihres Passworts an",
                submitButtonText: "Link anfordern",
                success: "Ein Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail Adresse geschickt.",
                error: "Bitte versuchen Sie es erneut."
            };
        case LoginMode.LOGIN:
        default:
            return {
                mode: LoginMode.LOGIN,
                title: "Anmeldung",
                submitButtonText: "Anmelden",
                success: "Anmeldung erfolgreich",
                error: "Die E-Mail Adresse oder das Passwort ist falsch."
            };
    }
};
const determineDedicatedErrorMessage = err => {
    if (err && err.code) {
        if (err.code == "auth/weak-password") {
            return "Das Passwort ist zu schwach. Es muss mindestens 6 Zeichen lang sein.";
        }
        else if (err.code == "auth/invalid-email") {
            return "Ungültige E-Mail Adresse.";
        }
        else if (err.code == "auth/email-already-in-use") {
            return "Für diese E-Mail Adresse gibt es bereits ein Kundenkonto.";
        }
        else if (err.message == "INVALID_PASSWORD") {
            return "Das Passwort ist falsch.";
        }
        else {
            return "Unbekannter Fehler. Bitte versuchen Sie es erneut oder wenden Sie sich an aboservice@makroskop.eu.";
        }
    }
};
